import { render, staticRenderFns } from "./data.vue?vue&type=template&id=18d39741&scoped=true"
import script from "./data.vue?vue&type=script&lang=js"
export * from "./data.vue?vue&type=script&lang=js"
import style0 from "./data.vue?vue&type=style&index=0&id=18d39741&prod&lang=scss"
import style1 from "./data.vue?vue&type=style&index=1&id=18d39741&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d39741",
  null
  
)

export default component.exports